import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import { Router, Route, useRouterHistory, IndexRoute } from 'react-router'
import { createHistory } from 'history'
const appHistory = useRouterHistory(createHistory)({
  basename: "/artbox"
})

import 'autotrack/lib/plugins/outbound-link-tracker'

import ReactGA from 'react-ga'
ReactGA.initialize('UA-9270190-1')
ReactGA.plugin.require('outboundLinkTracker')
function logPageView() {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
}

import App from './App'
import TopComponent from './components/TopComponent'
import MandalaComponent from './components/MandalaComponent'

ReactDOM.render(
  <Router history={appHistory} onUpdate={logPageView}>
    <Route path="/" component={App}>
      <IndexRoute component={TopComponent} />
      <Route path="/:mandalaTitle" component={MandalaComponent} />
    </Route>
  </Router>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/